import { CustomerOrderLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/customerOrderLinePartConfiguratorType";
import { UnsavedCustomerOfferLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/unsavedCustomerOfferLinePartConfiguratorType";
import { CustomerOrderOfferLine } from "src/api/generated/erp/db/types/tables/customerOrderOfferLine";
import { CustomerOrderLine } from "src/api/generated/erp/db/types/tables/customerOrderLine.ts";
import { UnsavedCustomerOrderLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/unsavedCustomerOrderLinePartConfiguratorType.ts";
import { ShopOrderLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/shopOrderLinePartConfiguratorType.ts";
import { ShopOrderPartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/shopOrderPartConfiguratorType.ts";
import { PurchaseOrderLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/purchaseOrderLinePartConfiguratorType.ts";
import { CustomerOrderOfferLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/customerOrderOfferLinePartConfiguratorType.ts";
import { ProjectActivityMaterialPartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/projectActivityMaterialPartConfiguratorType.ts";
import { UnsavedShopOrderPartConfiguratorType } from
	"src/api/generated/erp/configurator/configuratorType/impl/unsavedShopOrderPartConfiguratorType.ts";

export function createCustomerOrderLineConfiguratorType(
	customerOrderLineId: number,
	testContextEnabled = false,
): CustomerOrderLinePartConfiguratorType {
	return {
		type: "customerOrderLine",
		customerOrderLineId: customerOrderLineId,
		explicitPartConfigurationId: null,
		testContextEnabled,
	};
}

export function createCustomerOfferLineConfiguratorType(
	customerOfferLineId: number,
	testContextEnabled = false,
): CustomerOrderOfferLinePartConfiguratorType {
	return {
		type: "customerOrderOfferLine",
		customerOrderOfferLineId: customerOfferLineId,
		explicitPartConfigurationId: null,
		testContextEnabled,
	};
}

export function createUnsavedCustomerOrderLineConfiguratorType({
	customerOrderLine,
	initialValuesFromConfigurationId,
	clientStorageKey,
}: {
	customerOrderLine: CustomerOrderLine;
	initialValuesFromConfigurationId: number | undefined;
	clientStorageKey: string;
}): UnsavedCustomerOrderLinePartConfiguratorType {
	return {
		type: "unsavedCustomerOrderLine",
		customerOrderId: customerOrderLine.customerOrderId,
		plannedDeliveryDate: customerOrderLine.plannedDeliveryDate,
		salesPartId: customerOrderLine.salesPartId,
		initialValuesFromConfigurationId: initialValuesFromConfigurationId,
		clientStorageKey: clientStorageKey,
	};
}

export function createUnsavedCustomerOfferLineConfiguratorType({
	customerOfferLine,
	clientStorageKey,
}: {
	customerOfferLine: CustomerOrderOfferLine;
	clientStorageKey: string;
}): UnsavedCustomerOfferLinePartConfiguratorType {
	return {
		type: "unsavedCustomerOfferLine",
		customerOfferId: customerOfferLine.customerOrderOfferId,
		plannedDeliveryDate: customerOfferLine.plannedDeliveryDate,
		salesPartId: customerOfferLine.salesPartId,
		initialValuesFromConfigurationId: null,
		clientStorageKey: clientStorageKey,
	};
}

export function createProjectActivityMaterialPartConfiguratorType(
	activityMaterialLineId: number,
): ProjectActivityMaterialPartConfiguratorType {
	return {
		type: "projectActivityMaterial",
		activityMaterialLineId: activityMaterialLineId,
		explicitPartConfigurationId: null,
	};
}

export function createPurchaseOrderLinePartConfiguratorType(
	purchaseOrderLineId: number,
): PurchaseOrderLinePartConfiguratorType {
	return {
		type: "purchaseOrderLine",
		purchaseOrderLineId: purchaseOrderLineId,
		explicitPartConfigurationId: null,
	};
}

export function createShopOrderPartConfiguratorType(shopOrderId: number): ShopOrderPartConfiguratorType {
	return {
		type: "shopOrder",
		shopOrderId: shopOrderId,
		explicitPartConfigurationId: null,
	};
}

export function createUnsavedShopOrderPartConfiguratorType(
	partId: number,
	clientStorageKey: string,
): UnsavedShopOrderPartConfiguratorType {
	return {
		type: "unsavedShopOrder",
		partId,
		clientStorageKey: `${clientStorageKey}#part=${partId}`,
	};
}

export function createShopOrderLinePartConfiguratorType(shopOrderLineId: number): ShopOrderLinePartConfiguratorType {
	return {
		type: "shopOrderLine",
		shopOrderLineId: shopOrderLineId,
		explicitPartConfigurationId: null,
	};
}
